<p-toast life="10000" />
<p-confirmdialog [style]="{ maxWidth: '50vw' }" />

<app-top-bar></app-top-bar>
<div class="router-wrapper">
  <router-outlet />
</div>
